// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
var videoPage = false;

$(document).ready(function(){

  $('.slide-to').click(function(e) {
      var aid = $(this).attr('href');
      if(aid.includes('#')) {
        e.preventDefault();
        $('html,body').animate({scrollTop: ($(aid).offset().top - 20)},'slow');
      }
  });
  if($('.vimeo-wrapper').length) {
    videoPage = true;
    $('.content').addClass('view-top-marging');
  } 

  $('.read-more').click(function(){
    $(this).parent().css('max-height', '100%');
    $(this).hide();
  })

  $('#menuBtn').click(function(){
    if($(this).hasClass('open')) {
      $(this).find('.fa-times').first().hide();
      $(this).find('.fa-bars').first().show();
      if(videoPage) {
        if( $(window).scrollTop() < $('.vimeo-wrapper').first().height()) {
          $('#mainNav').addClass('text-light');
          $('#mainNav').removeClass('bg-white');
        }
      }
      $(this).removeClass('open');
    } else {
      $(this).find('.fa-bars').first().hide();
      $(this).find('.fa-times').first().show();
      $(this).addClass('open');
    }
  });

  // color swapper for navbar
  // var stickyOffset = $('#mainNav').offset();
  // var navHeight = $('#mainNav').height();
  // var $contentDivs = $('.section');
  // $(document).scroll(function() {
  //     $contentDivs.each(function() {
  //         var _thisOffset = $(this).offset();
  //         var _actPosition = (_thisOffset.top - navHeight) - $(window).scrollTop();
  //         if (_actPosition < stickyOffset.top && _actPosition + $(this).height() > 0) {
  //             $('#mainNav').removeClass('text-light text-dark bg-white').addClass($(this).hasClass('light') ? 'text-light' : 'text-dark');
  //             return false;
  //         }
  //     });
  // });

  if (window.location.href.indexOf('?price=') > -1) {
    $('html, body').animate({ scrollTop: 550 }, 1000);
  }

//   var windowWidth = $(window).width();
//   // slider
//   $('.slider-wrap').each(function(){
//       var slider = $(this).find('.slider').first();
//       var $progressBar = $(this).find('.progress').first();
//       var $progressBarLabel = $(this).find( '.slider__label' ).first();
//       var countSlides = slider.find('.image').length;

//       var slidesToShow = 3;
//       if(windowWidth < 576) {
//         slidesToShow = 1;
//       } else if(windowWidth < 768) {
//         slidesToShow = 2;
//       }
//       if(countSlides > slidesToShow) {
//         slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
//           var calc = ( (nextSlide) / (slick.slideCount) ) * 100;
          
//           $progressBar
//             .css('background-size', calc + '% 100%')
//             .attr('aria-valuenow', calc );
          
//           $progressBarLabel.text( calc + '% completed' );
//         });
  
//         slider.slick({
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           autoplay: true,
//           autoplaySpeed: 1,
//           speed: 6000,
//           infinite: true,
//           pauseOnHover: true,
//           waitForAnimate: false,
//           cssEase: 'linear',
//           centerMode: false,
//           responsive: [
//             {
//               breakpoint: 768,
//               settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 2,
//               },
//             },
//             {
//               breakpoint: 576,
//               settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//               },
//             },
//             // You can unslick at a given breakpoint now by adding:
//             // settings: "unslick"
//             // instead of a settings object
//           ],
//         });
//         // slider.on('swipe', function(event, slick, direction){
//         //   event.preventDefault();
//         //   console.log(event);
//         //   if(direction == 'left') {
//         //     slider.slick('slickGoTo', slider.slick('slickCurrentSlide') + 1, false);
//         //   } else {
//         //     slider.slick('slickGoTo', slider.slick('slickCurrentSlide') - 1, false);
//         //   }
//         //   // left
//         // });
//         // slider.on('swipe', function(event, slick, direction){
//         //   for (var i = 0; i < 9999; i++) {
//         //     window.clearInterval(i);
//         // }
//         //   console.log(event, slick, direction);
//         //   slider.slick('slickSetOption', 'speed', 1, true)
//         //   slider.slick('slickNext')
//         //   slider.slick('slickSetOption', 'speed', 6000, true)
//         //   // left
//         // });  
//       } else {
//         $(this).find('.progress').hide();
//       }
//   });
});


// WEBPACK FOOTER //
// ./scripts/main.js